import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editScreen,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  GridFlag,
  BooleanFlagFilterCell,
}) => {
  const dataColumns = [
    {
      field: 'RoleId',
      title: 'Role Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Name',
      title: 'Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: false,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editScreen(props.dataItem);
          }}
        >
          {props.dataItem.Name}
        </td>
      ),
    },
    {
      field: 'RoleCatId',
      title: 'Role Category',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Desc',
      title: 'Description',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: false,
      excludeFromFilter: true,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterable: false,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: false,
      width: '200px',
      filterable: false,
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: false,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterable: false,
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: false,
      width: '200px',
      filterable: false,
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: false,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterable: false,
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
